import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestPersonalReportDto, ResponsePersonalReportSendEmailDto } from '../dto/personal-report.dto';


@Injectable()
export class PersonalReportApi {

  private service: string = '';
  private model: string = 'report/personal';
  private timeout: number = (5 * 60) * 1000;

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadExcel(data: RequestPersonalReportDto) {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: RequestPersonalReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public downloadPdf(data: RequestPersonalReportDto) {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: RequestPersonalReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public reportSendEmailExcel(data: RequestPersonalReportDto): Observable<ResponsePersonalReportSendEmailDto> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: RequestPersonalReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePersonalReportSendEmailDto>(method, url, params, urlParams, body, null, this.timeout);
  }

  public reportSendEmailPdf(data: RequestPersonalReportDto) {
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: RequestPersonalReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePersonalReportSendEmailDto>(method, url, params, urlParams, body, null, this.timeout);
  }
  
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/personal-report.api.ts